<template>
  <div>
    <div class="crpg-m-private-cruising-photo-gallery">
      <div class="crpg-m-private-cruising-photo-gallery__contents">
        <swiper :options="swiperOption" ref="swiper">
          <swiper-slide v-for="(item, index) in image" :key="index">
            <AtomsPrivateCruisingPhotoGallery :path="item"
          /></swiper-slide>
        </swiper>
      </div>
    </div>
    <div slot="button-prev" class="swiper-button-prev"></div>
    <div slot="button-next" class="swiper-button-next"></div>
  </div>
</template>

<script>
import AtomsPrivateCruisingPhotoGallery from "@/components/atoms/privateCruising/PhotoGallery.vue";

export default {
  name: "MoleculesPrivateCruisingPhotoGallery",
  components: {
    AtomsPrivateCruisingPhotoGallery,
  },
  props: {
    image: {
      type: Array,
    },
  },
  data() {
    /**
     * swiperの設定
     */
    return {
      swiperOption: {
        autoplay: false,
        spaceBetween: 10,
        centeredSlides: false,
        loop: false,
        slidesPerView: 2,
        breakpoints: {
          800: {
            slidesPerView: 4,
          },
          500: {
            slidesPerView: 3,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/molecules/privateCruising/photoGallery.scss";
</style>
